import React from 'react';
import { Modal } from 'react-bootstrap';
import { convertTimeToCurrentTimeZone } from '../../../helper';

// entries: pre-normalized [{ label, detail, by, at }], newest first.
const AuditTrail = ({ show, setShow, title = 'Audit Trail', entries = [], timezone }) => {
    return (
        <Modal
            dialogClassName="h_auto"
            show={show}
            size='md'
            animation={false}
            centered
        >
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
                <span className="modal_close" onClick={() => setShow(false)}><i className="icon-cross" /></span>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex flex-column" style={{ gap: '16px' }}>
                    {entries.map((entry, i) => (
                        <div key={i} className="d-flex" style={{ gap: '12px' }}>
                            <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#842014', marginTop: '6px', flexShrink: 0 }} />
                            <div>
                                <div style={{ fontWeight: 700 }}>{entry.label}</div>
                                {entry.detail ? <div className="text-muted" style={{ fontSize: '0.85rem' }}>{entry.detail}</div> : null}
                                <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                                    {entry.by}{entry.at ? ` • ${convertTimeToCurrentTimeZone(entry.at, timezone, 'MM/DD/YY hh:mm a')}` : ''}
                                </div>
                            </div>
                        </div>
                    ))}
                    {!entries.length ? <p className="text-muted mb-0">No audit history available.</p> : null}
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default AuditTrail;
